import Vue from "vue"
import Vuex from "vuex";
// import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [],
    state: {
        yourWinningsSelected: false,
        userData: undefined,
        isLoading: false,
        sportsWithActiveRounds: new Map(),
        roundFixtures: [],
        roundPredictions: [],
        selectedRound: undefined,
        selectedRoundConfigMap: undefined,
        selectedSport: undefined,
        selectedLeague: undefined,
        pointsScoringBreakdown: undefined,
        showHowToEarnPointsModal: false,
        leaderBoardSportSelected: undefined,
        leaderboardSelectedUser: undefined,
        token: undefined,
    },
    mutations: {
        setLeaderboardSelectedUser(state, user) {
            state.leaderboardSelectedUser = user
        },
        setLeaderBoardSportSelected(state, sport) {
            state.leaderBoardSportSelected = sport;
        },
        setIsYourWinningsSelected(state, boolean) {
            state.yourWinningsSelected = boolean
        },
        setUserData(state, userData) {
            state.userData = userData;
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading;
        },
        setSelectedSport(state, sport) {
            state.selectedSport = sport
        },
        setSelectedLeague(state, league) {
            state.selectedLeague = league
        },
        setSportsWithActiveRounds(state, sportsWithActiveRounds) {
            state.sportsWithActiveRounds = sportsWithActiveRounds;
        },
        setSportsWithActivePredictions(state, sport) {
            state.sportsWithActivePredictions.push(sport);
        },
        setLeaguesWithActiveRounds(state, leaguesWithActiveRounds) {
            state.leaguesWithActiveRounds = leaguesWithActiveRounds;
        },
        setLeaguesWithActivePrediction(state, displayName) {
            state.leuguesWithActivePredictions.push(displayName)
        },
        setEplSoccerRoundId(state, roundId) {
            state.soccerRoundsIds.epl = roundId
        },
        setSelectedRoundConfigMap(state, map) {
            state.selectedRoundConfigMap = map
        },
        setSelectedRound(state, roundId) {
            state.selectedRound = roundId
        },
        setPslSoccerRoundId(state, roundId) {
            state.soccerRoundsIds.psl = roundId
        },
        setUEFASoccerRoundId(state, roundId) {
            state.soccerRoundsIds.chmp = roundId
        },
        setRoundFixtures(state, fixture) {
            state.roundFixtures.push(fixture)
        },
        setRoundPredictions(state, fixture) {
            state.roundPredictions.push(fixture)
        },
        clearRoundPredictions(state) {
            state.roundPredictions = [];
        },
        clearSportsWithActiveRounds(state) {
            state.sportsWithActiveRounds = new Map();
        },
        clearSportsWithActivePredictions(state) {
            state.sportsWithActivePredictions = [];
        },
        clearLeaguesWithActiveRounds(state) {
            state.leaguesWithActiveRounds = [];
        },
        clearLeuguesWithActivePredictions(state) {
            state.leuguesWithActivePredictions = [];
        },
        setPointsScoringBreakdown(state, pointsScoringBreakdown) {
            state.pointsScoringBreakdown = pointsScoringBreakdown;
        },
        toggleShowHowToEarnPointsModal(state) {
            state.showHowToEarnPointsModal = !state.showHowToEarnPointsModal;
        },
        setToken(state, token) {
            state.token = token;
        },
        setVodacomFantasyHost(state, vodacomFantasyHost) {
            state.vodacomFantasyHost = vodacomFantasyHost;
        }
    },
    modules: {}
})
